import React,{useContext,useState} from 'react'
import {
    Grid, 
    SearchBar, 
    SearchContext, 
    SearchContextManager, 
    SuggestionBar, 
} from '@giphy/react-components'
import './ConversationStyleSheet.css';
import uuid from "react-uuid";
import xmppService from "../Services/XMPPService";
import { MessageType } from "./MessageBoxTypes/Message";





const Gif = (props) => {

    const [gif, setGif] = useState();
    const { fetchGifs, searchKey } = useContext(SearchContext)

    const handleClick=(gif, e) => {
           let textMessage = "https://media.giphy.com/media/"+gif.id+"/giphy.gif"
           console.log("data..em",textMessage)
           let messageTime = new Date();
           
            let newMessageToSend = { message: { text: textMessage, sentTimestamp: messageTime.getTime() }, id: uuid(), type: MessageType.sent, timestamp: messageTime.getTime(), convoType: "IMAGE", creator: "CUSTOMER", syntheticMessage: true }
           let sessionInfo = props.activeConversation;
           console.log("session info",sessionInfo)
           let message = { text: textMessage, sentTimestamp: messageTime.getTime(),conversationId:sessionInfo.sessionId }
    //       let message = { text: textMessage, sentTimestamp: messageTime.getTime() }
           xmppService.sendGif(sessionInfo.sessionId, message, "IMAGE").then(result => {
               props.addMessagesToList([newMessageToSend]);
           }).catch(error => { console.log("Could Not Send Gif"); });
           props.handleClose();         

      }
    return (
        <>
            <SearchBar style={{marginBottom:"100px"}}  placeholder={'Search'} mode ={"light"}/>
            <SuggestionBar searchbarHeight={200}/>
            <Grid key={searchKey} columns={3} width={320} height={50} fetchGifs={fetchGifs}   initialGifs={[]}
    loader={undefined} noLink={true} noResultsMessage={"No result found !!"}  layoutType={'MIXED'} onGifClick={handleClick} />
        </>
    )

    
}



 export default Gif;